/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduleDto } from '../../models/schedule-dto';

export interface ScheduleControllerFindByIdV1$Params {
  id: string;
}

export function scheduleControllerFindByIdV1(http: HttpClient, rootUrl: string, params: ScheduleControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, scheduleControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduleDto>;
    })
  );
}

scheduleControllerFindByIdV1.PATH = '/api/v1/schedule/{id}';
